import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import getPartnerAccount from '../services/partners/getPartnerAccount'

// THUNKS
export const fetchPartnerAccount = createAsyncThunk('partner/fetchPartnerAccount', getPartnerAccount.handler);

const user_initial_state = {
	account_id: null,
	user_id: null,
	resource_id: 'SELF',
	date_of_birth: null,
	agreement: {
		declaration: null,
		service: null,
		pdpa: null,
	},
	enabled: true,
	status: 'REGISTRATION:PENDING_APPROVAL',
	account_type: null,
	stripe_account_id: null,
	application_location: null,
	created: null,
	modified: null,
	payment_account: {
		name: null,
		bank_name: null,
		account_number: null,
		bank_statement_image: {
			bucket: null,
			key: null,
		},
	},
	stripe_account: {
		id: null,
		charges_enabled: false,
		details_submitted: false,
	},
	individual: {
		name: null,
		race: null,
		gender: null,
		emergency_contact: {
			name: null,
			phone_number: null,
		},
		address: {
			country: null,
			state: null,
			address2: null,
			city: null,
			address1: null,
			poscode: null,
		},
		identification_number: null,
		identification_number_image: {
			bucket: null,
			key: null,
		},
		user_id: null,
		email: null,
		phone_number: null,
		picture: {
			bucket: null,
			key: null,
		},
	},
	electrical_competency: {
		electrical_wiring: {
			not_applicable: false,
			years_of_experience: null,
			highest_level: null,
			file: {
				bucket: null,
				key: null,
			}
		},
		chargeman: {
			not_applicable: false,
			years_of_experience: null,
			highest_level: null,
			file: {
				bucket: null,
				key: null,
			}
		},
	},
	driving_license: {
		expiry_date: null,
		image: {
			bucket: null,
			key: null,
		},
	},
	vehicle: {
		name: null,
		registration_number: null,
		type: null,
		roadtax: {
			expiry_date: null,
			image: {
				bucket: null,
				key: null,
			},
		}
	},
	registration_toolkit: {
		shirt_size: null,
		invoice: null,
	},
	completion: {
		personal_information: false,
		service_agreement: false,
		documents_collection: false,
		stripe: false,
		training_videos: [],
		equipment_purchase: false,
	},
};

// const user_initial_state = {
// 	"driving_license": {
// 			"expiry_date": "2026-03-03T06:08:20.000Z",
// 			"image": {
// 					"bucket": "swifix-dev-sharedbucket",
// 					"key": "protected/ap-southeast-1:986c7181-c961-c1f4-8ab5-bfc3d7c1a7a1/images/driving_license.jpg"
// 			}
// 	},
// 	"status": "REGISTRATION:PENDING_APPROVAL",
// 	"created": "2025-03-01T07:01:13.563Z",
// 	"payment_account": {
// 			"account_number": "123456789",
// 			"bank_name": "BSN",
// 			"bank_statement_image": {
// 					"bucket": "swifix-dev-sharedbucket",
// 					"key": "protected/ap-southeast-1:986c7181-c961-c1f4-8ab5-bfc3d7c1a7a1/images/bank_statement.jpg"
// 			},
// 			"name": "Menenet"
// 	},
// 	"date_of_birth": "1991-02-21T16:00:00.000Z",
// 	"account_id": "d95a250c-80b1-7031-f5da-f0001094b869",
// 	"resource_id": "SELF",
// 	"vehicle": {
// 			"name": "Motorku",
// 			"registration_number": "ABC 123",
// 			"roadtax": {
// 					"expiry_date": "2027-03-03T06:09:29.000Z",
// 					"image": {
// 							"bucket": "swifix-dev-sharedbucket",
// 							"key": "protected/ap-southeast-1:986c7181-c961-c1f4-8ab5-bfc3d7c1a7a1/images/vehicle_roadtax.jpg"
// 					}
// 			},
// 			"type": "motorcycle"
// 	},
// 	"enabled": true,
// 	"user_id": "d95a250c-80b1-7031-f5da-f0001094b869",
// 	"electrical_competency": {
// 			"chargeman": {
// 					"file": {
// 							"bucket": "swifix-dev-sharedbucket",
// 							"key": "protected/ap-southeast-1:986c7181-c961-c1f4-8ab5-bfc3d7c1a7a1/images/electrical-chargeman-certification.jpg"
// 					},
// 					"highest_level": "A1",
// 					"not_applicable": false,
// 					"years_of_experience": "5_to_10_years"
// 			},
// 			"electrical_wiring": {
// 					"file": {
// 							"bucket": "swifix-dev-sharedbucket",
// 							"key": "protected/ap-southeast-1:986c7181-c961-c1f4-8ab5-bfc3d7c1a7a1/images/electrical-wiring-certification.jpg"
// 					},
// 					"highest_level": "PW2",
// 					"not_applicable": false,
// 					"years_of_experience": "3_to_5_years"
// 			}
// 	},
// 	"stripe_account": {
// 			"charges_enabled": true,
// 			"details_submitted": true,
// 			"id": "acct_1QySZr2KbQsNAEjH"
// 	},
// 	"stripe_account_id": "acct_1QySZr2KbQsNAEjH",
// 	"application_location": {
// 			"country": "MYS",
// 			"created": "2024-09-25T05:55:51.290Z",
// 			"municipality": "Sungai Petani",
// 			"modified": "2024-09-25T05:55:51.290Z",
// 			"state": "Kedah",
// 			"enabled": true,
// 			"queue": {
// 					"name": "dev-mys-kedah-sungai_petani.fifo",
// 					"url": "https://sqs.ap-southeast-1.amazonaws.com/654654407113/dev-mys-kedah-sungai_petani.fifo"
// 			}
// 	},
// 	"individual": {
// 			"address": {
// 					"country": "Malaysia",
// 					"state": "Kedah",
// 					"address2": "Ambangan Height",
// 					"city": "Sungai Petani",
// 					"address1": "No 123, Jalan Melor 3/12",
// 					"poscode": "05000"
// 			},
// 			"email": "neuko.team@gmail.com",
// 			"emergency_contact": {
// 					"name": null,
// 					"phone_number": null
// 			},
// 			"gender": "male",
// 			"identification_number": "801214058453",
// 			"identification_number_image": {
// 					"bucket": "swifix-dev-sharedbucket",
// 					"key": "protected/ap-southeast-1:986c7181-c961-c1f4-8ab5-bfc3d7c1a7a1/images/identification_card.jpg"
// 			},
// 			"name": "Wan Shamarul Arifin Bin Wan Tajuddin",
// 			"phone_number": "+60164128784",
// 			"picture": {
// 					"bucket": "swifix-dev-sharedbucket",
// 					"key": "public/ap-southeast-1:986c7181-c961-c1f4-8ab5-bfc3d7c1a7a1/images/personal_picture.jpg"
// 			},
// 			"race": "chinese",
// 			"user_id": "d95a250c-80b1-7031-f5da-f0001094b869"
// 	},
// 	"agreement": {
// 			"declaration": "2025-03-03T01:50:32.520Z",
// 			"pdpa": "2025-03-03T01:50:27.084Z",
// 			"service": "2025-03-03T01:50:34.219Z"
// 	},
// 	"account_type": null,
// 	"registration_toolkit": {
// 			"invoice": {
// 					"amount_paid": 30000,
// 					"amount_remaining": 0,
// 					"customer_shipping": null,
// 					"metadata": {
// 							"job_type": "null",
// 							"user_id": "d95a250c-80b1-7031-f5da-f0001094b869",
// 							"job_id": "null",
// 							"purchase_id": "null",
// 							"locality": "null",
// 							"event": "partner.purchase.toolkit",
// 							"success_next_event": "partner.purchase.toolkit"
// 					},
// 					"livemode": false,
// 					"total_tax_amounts": [],
// 					"discount": null,
// 					"amount_shipping": 0,
// 					"issuer": {
// 							"type": "self"
// 					},
// 					"statement_descriptor": null,
// 					"transfer_data": null,
// 					"number": "183A779C-0001",
// 					"quote": null,
// 					"auto_advance": false,
// 					"discounts": [],
// 					"subtotal_excluding_tax": 30000,
// 					"period_start": 1741158387,
// 					"from_invoice": null,
// 					"amount_due": 30000,
// 					"id": "in_1QzC2CRojjIe83BkEtzQryof",
// 					"payment_settings": {
// 							"default_mandate": null,
// 							"payment_method_types": null,
// 							"payment_method_options": null
// 					},
// 					"customer_address": {
// 							"country": "MY",
// 							"state": "Kedah",
// 							"postal_code": "05000",
// 							"city": "Sungai Petani",
// 							"line2": "Ambangan Height",
// 							"line1": "No 123, Jalan Melor 3/12"
// 					},
// 					"test_clock": null,
// 					"paid_out_of_band": false,
// 					"on_behalf_of": null,
// 					"created": 1741158387,
// 					"custom_fields": null,
// 					"customer_phone": null,
// 					"ending_balance": 0,
// 					"rendering": {
// 							"template": null,
// 							"amount_tax_display": null,
// 							"pdf": {
// 									"page_size": "letter"
// 							},
// 							"template_version": null
// 					},
// 					"tax": null,
// 					"period_end": 1741158387,
// 					"webhooks_delivered_at": 1741158387,
// 					"subscription_details": {
// 							"metadata": null
// 					},
// 					"subtotal": 30000,
// 					"customer_email": "neuko.team@gmail.com",
// 					"payment_intent": "pi_3QzC26RojjIe83Bk1EWpmUPp",
// 					"next_payment_attempt": null,
// 					"application_fee_amount": null,
// 					"automatically_finalizes_at": null,
// 					"object": "invoice",
// 					"status": "paid",
// 					"invoice_pdf": "https://pay.stripe.com/invoice/acct_1P6iV3RojjIe83Bk/test_YWNjdF8xUDZpVjNSb2pqSWU4M0JrLF9Sc3h5Smd1MFdyZWEyWFdsdGlmclhxWWxqdFNNQmlwLDEzMTY5OTIwMA0200nRnbdeH9/pdf?s=ap",
// 					"footer": null,
// 					"shipping_details": null,
// 					"description": null,
// 					"subscription": null,
// 					"starting_balance": 0,
// 					"total": 30000,
// 					"pre_payment_credit_notes_amount": 0,
// 					"total_pretax_credit_amounts": [],
// 					"account_name": "Swifix",
// 					"currency": "myr",
// 					"account_country": "MY",
// 					"lines": {
// 							"has_more": false,
// 							"data": [
// 									{
// 											"unit_amount_excluding_tax": "30000",
// 											"metadata": {},
// 											"livemode": false,
// 											"pretax_credit_amounts": [],
// 											"description": "Strategic Partner Toolkits - XL",
// 											"subscription": null,
// 											"type": "invoiceitem",
// 											"discounts": [],
// 											"price": {
// 													"tax_behavior": "unspecified",
// 													"metadata": {},
// 													"product": "prod_RpXn3L3566gnxZ",
// 													"livemode": false,
// 													"created": 1740369098,
// 													"recurring": null,
// 													"active": true,
// 													"unit_amount_decimal": "30000",
// 													"billing_scheme": "per_unit",
// 													"unit_amount": 30000,
// 													"type": "one_time",
// 													"transform_quantity": null,
// 													"tiers_mode": null,
// 													"nickname": null,
// 													"lookup_key": null,
// 													"currency": "myr",
// 													"id": "price_1QvshiRojjIe83BkRwrZgy9a",
// 													"custom_unit_amount": null,
// 													"object": "price"
// 											},
// 											"amount_excluding_tax": 30000,
// 											"currency": "myr",
// 											"id": "il_1QzC2CRojjIe83BkOVcXC344",
// 											"discountable": true,
// 											"plan": null,
// 											"discount_amounts": [],
// 											"amount": 30000,
// 											"period": {
// 													"start": 1741158388,
// 													"end": 1741158388
// 											},
// 											"quantity": 1,
// 											"proration": false,
// 											"tax_amounts": [],
// 											"tax_rates": [],
// 											"invoice_item": "ii_1QzC2CRojjIe83BkSZGCSXc4",
// 											"proration_details": {
// 													"credited_items": null
// 											},
// 											"invoice": "in_1QzC2CRojjIe83BkEtzQryof",
// 											"object": "line_item"
// 									}
// 							],
// 							"total_count": 1,
// 							"url": "/v1/invoices/in_1QzC2CRojjIe83BkEtzQryof/lines",
// 							"object": "list"
// 					},
// 					"total_discount_amounts": [],
// 					"attempt_count": 1,
// 					"default_tax_rates": [],
// 					"charge": "py_3QzC26RojjIe83Bk1EmCdHF6",
// 					"last_finalization_error": null,
// 					"default_source": null,
// 					"shipping_cost": null,
// 					"total_excluding_tax": 30000,
// 					"post_payment_credit_notes_amount": 0,
// 					"default_payment_method": null,
// 					"due_date": 1741158387,
// 					"billing_reason": "manual",
// 					"effective_at": 1741158387,
// 					"account_tax_ids": null,
// 					"automatic_tax": {
// 							"disabled_reason": null,
// 							"enabled": false,
// 							"liability": null,
// 							"status": null
// 					},
// 					"receipt_number": null,
// 					"application": null,
// 					"collection_method": "send_invoice",
// 					"customer_tax_ids": [],
// 					"hosted_invoice_url": "https://invoice.stripe.com/i/acct_1P6iV3RojjIe83Bk/test_YWNjdF8xUDZpVjNSb2pqSWU4M0JrLF9Sc3h5Smd1MFdyZWEyWFdsdGlmclhxWWxqdFNNQmlwLDEzMTY5OTIwMA0200nRnbdeH9?s=ap",
// 					"paid": true,
// 					"attempted": true,
// 					"customer_name": "Popoi",
// 					"status_transitions": {
// 							"finalized_at": 1741158387,
// 							"paid_at": 1741158387,
// 							"voided_at": null,
// 							"marked_uncollectible_at": null
// 					},
// 					"customer": "cus_RsCz8gnO2wneFC",
// 					"customer_tax_exempt": "none",
// 					"latest_revision": null
// 			},
// 			"shirt_size": "XL"
// 	},
// 	"modified": "2025-03-05T07:06:43.925Z",
// 	"completion": {
// 			"documents_collection": true,
// 			"equipment_purchase": true,
// 			"personal_information": true,
// 			"service_agreement": true,
// 			"stripe": false,
// 			"training_videos": [
// 					{
// 							"completed": true,
// 							"description": "Lorem ipsum lalal balla chong chong ggyehh",
// 							"title": "Training nombor 1",
// 							"url": "https://swifix.my/wp-content/uploads/2025/02/samplevideo2.mov"
// 					},
// 					{
// 							"completed": true,
// 							"description": "Lorem sfkjd lalal balla chong sda jsojhd 3949 djnbjijskdf",
// 							"title": "Training nombor 2",
// 							"url": "https://swifix.my/wp-content/uploads/2025/02/samplevideo2.mov"
// 					}
// 			]
// 	}
// }

// slice definition
const slice = createSlice({
	name: 'partner',
	initialState: user_initial_state,
	reducers: {},
	extraReducers: builder => {
		builder

			// dehydrateUser
			.addCase(fetchPartnerAccount.pending, getPartnerAccount.pending)
			.addCase(fetchPartnerAccount.fulfilled, getPartnerAccount.fulfilled)
			.addCase(fetchPartnerAccount.rejected, getPartnerAccount.rejected)
	},
});

// export const { mutateUserProfile } = slice.actions;
const { reducer } = slice;
export default reducer;